export function carsSlider() {
    document.addEventListener('DOMContentLoaded', function () {
        const carsSlider = document.querySelectorAll('.blockCarsSlider .splide');
        if (!carsSlider) return;

        carsSlider.forEach(slider => {
            const apiId = slider.closest('.blockCarsSlider').dataset.apiId;
            const splideSlider = new window.splide(slider, {
                type: 'carousel',
                autoplay: true,
                perPage: 3,
                perMove: 1,
                pagination: false,
                gap: '40px',
                breakpoints: {
                    767: {
                        perPage: 1,
                    },
                }
            });

            const resultsText = slider.closest('.blockCarsSlider').querySelector('.blockCarsSlider__text span');
            if (resultsText) {
                fetchCars(apiId, splideSlider, resultsText);
            } else {
                console.error('Error: .blockCarsSlider__text span element not found!');
            }
        });
    });
}
function fetchCars(apiId, splideSlider, resultsText) {
    const apiUrl = 'https://amapi.azurewebsites.net/public/get-collection-by-id';
    const apiBody = {
        id: apiId,
        length: 12
    };

    fetch(apiUrl, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-API-Key': 'asx99x21'
        },
        body: JSON.stringify(apiBody)
    })
        .then(response => response.json())
        .then(data => {
            const carList = data.result;
            const totalResults = data.pagination.total; // Get total number of results
            const filters = data.filters; // Get filters from the API response
            const splideList = splideSlider.root.querySelector('.splide__list');

            const baseUrl = `${window.location.origin}/wyniki-wyszukiwania/?`;
            const filterParams = [];

            Object.entries(filters).forEach(([key, value]) => {
                if (value !== null && value !== '') { // Check for non-null and non-empty values
                    const paramValue = Array.isArray(value) ? encodeURIComponent(value.join(',')) : encodeURIComponent(value);
                    filterParams.push(`${key}=${paramValue}`); // Use the key as the parameter name directly
                }
            });
            const filterLink = filterParams.length > 0 ? `${baseUrl}${filterParams.join('&')}` : '#';
            const seeAllLink = splideSlider.root.closest('.blockCarsSlider').querySelector('.blockCarsSlider__text a');


            if (seeAllLink) {
                seeAllLink.href = filterLink; // Update the link with filters
            }

            if (resultsText) {
                resultsText.textContent = `(${totalResults})`; // Display total results
            }

            carList.forEach(car => {
                const carItem = createCarSlide(car);
                splideList.insertAdjacentHTML('beforeend', carItem);
            });

            const sliderContainer = splideSlider.root.closest('.blockCarsSlider');
            sliderContainer.classList.remove('hide');

            splideSlider.mount();
        })
        .catch(error => {
            console.error('Error fetching cars:', error);
        });
}

function createCarSlide(car) {
    const domain = window.location.origin;
    const carPhoto = car.car_photo.photo[0];
    const carTitle = `${car.make} ${car.model} (${car.year})`;

    const currencySymbol = car.currency.char_code === 'USD' ? '$' : car.currency.char_code;
    const carPrice = `${currencySymbol}${car.est_retail_value}`;
    const lotNumber = car.lot_number;
    const carLink = `${domain}/wyniki-wyszukiwania/?lot_number=${lotNumber}`;

    return `
        <li class="splide__slide">
            <a href="${carLink}" class="car-slide">
                <div class="car-slide__img">
                    <img src="${carPhoto}" alt="${carTitle}">
                </div>
                <p class="car-slide__title">${carTitle}</p>
                <p class="car-slide__price">${carPrice}</p>
            </a>
        </li>
    `;
}
